export const GET_TRANSFERS_SUCCESS = 'GET_TRANSFERS_SUCCESS';
export const SET_TRANSFERS_LOADING = 'SET_TRANSFERS_LOADING';

export const GET_SUMMARY_SUCCESS = 'GET_TRANSFERS_SUMMARY_SUCCESS';
export const SET_SUMMARY_LOADING = 'SET_TRANSFERS_SUMMARY_LOADING';
